import CityServiceTemplate from "@/components/CityServiceTemplate";
import canyonLakeHero from "@/assets/cities/canyon-lake-hero.jpg";

const CarServiceCanyonLake = () => {
  return (
    <CityServiceTemplate
      cityName="Canyon Lake"
      cityDescription="Reliable black car service for Canyon Lake area residents and vacation rentals. From airport pickups to special events, we provide luxury transportation throughout the Hill Country."
      metaDescription="Black car service for Canyon Lake, TX. Airport transfers, vacation rental transportation, and event service. Professional chauffeur service by Rick's."
      canonicalPath="/canyon-lake-car-service"
      heroImage={canyonLakeHero}
      additionalContent="Canyon Lake visitors and residents enjoy hassle-free transportation with Rick's Black Car Service. Whether you're arriving for a lakeside vacation, heading to San Antonio for dining and entertainment, or need SAT Airport service, we deliver comfort and reliability every time."
      coordinates={{
        latitude: 29.8772,
        longitude: -98.2628
      }}
      serviceRadius="45 miles"
      featuredPricing={{
        route: "Canyon Lake ↔ SAT Airport",
        price: "~45 mi",
        note: "Pricing based on distance & time (includes 20% gratuity)"
      }}
      cityReviews={[
        {
          author: "Susan Harper",
          rating: 5,
          date: "2024-11-10",
          text: "Rick picked us up from our Canyon Lake vacation rental and took us to SAT Airport. Punctual, friendly, and the luxury SUV was perfect for our family. Will definitely book again for our next lake trip!"
        },
        {
          author: "David Newman",
          rating: 5,
          date: "2024-09-22",
          text: "Outstanding service from Canyon Lake to downtown San Antonio for our anniversary dinner. Rick made excellent restaurant recommendations too! A true professional."
        }
      ]}
    />
  );
};

export default CarServiceCanyonLake;
